import { getManagementMethodCodeDescription } from "encamp-shared/src/waste/validCodes";

/**
 * Summarize the distinct management method codes across a manifest's lines for
 * the manifest-level Receiving card. Management method is a per-line value, so
 * the card can only show a single code when every line agrees; otherwise it
 * reports how many distinct methods are in play.
 *
 * Returns undefined when there are no codes (the card omits the field entirely).
 */
export function summarizeManagementMethods(codes: readonly string[]): string | undefined {
  const distinct = [...new Set(codes.filter(Boolean).map((code) => code.toUpperCase()))].sort();
  if (distinct.length === 0) return undefined;
  if (distinct.length === 1) {
    const [code] = distinct;
    const name = getManagementMethodCodeDescription(code);
    return name ? `${code} · ${name}` : code;
  }
  return `Multiple (${distinct.length})`;
}
